/**
 * Shared constants - minimal extraction to reduce duplication
 * without changing CSS structure or behavior
 */

import onDiemLogoSvg from '../assets/onDiem_Logo.svg?raw';

/**
 * onDiem wordmark, inlined at build time. Used by the "powered by" lockup on
 * partner sites. Inlined rather than served from the CDN so the mark always
 * renders even if the CDN is unreachable. Intrinsic size is 92x19.
 */
export const ONDIEM_LOGO_SVG = onDiemLogoSvg;
export const ONDIEM_LOGO_WIDTH = 92;
export const ONDIEM_LOGO_HEIGHT = 19;

// CDN base URL
export const CDN_BASE = 'https://cdn.prod.website-files.com/6740eb2919ae7dd52a22fc96';

// CDN asset URLs
export const CDN_ASSETS = {
  SELECT_ARROW: `${CDN_BASE}/67f974a99730a127cbf3c8c0_select-arrow.svg`,
  MAP_ICON: `${CDN_BASE}/67ec3c42df056747590c0c2d_map-icon.svg`,
  ARROW_LEFT: `${CDN_BASE}/67ec529a4e8f495effc8535e_arrow-left.svg`,
  ARROW_RIGHT: `${CDN_BASE}/67f6c31fe31e172119b9c540_right-arrow.svg`,
  LAYERED_STACK_ICON: `${CDN_BASE}/68ae3a92ee10187b2c51894f_layered-stack-icon.svg`,
  CLOSE_ICON: `${CDN_BASE}/68af480b1bc53560746ff5fe_close-icon.svg`,
  CALENDAR_ICON: `${CDN_BASE}/68af3b9107e12c2649636636_blank-calendar-icon.svg`,
} as const;

// Font URL
export const FONT_URL = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap';

// Position types
export const POSITION_TYPES = [
  { value: 'dentist', label: 'Dentist' },
  { value: 'dental hygienist', label: 'Dental Hygienist' },
  { value: 'dental assistant', label: 'Dental Assistant' },
  { value: 'office staff', label: 'Office Staff' },
] as const;
